<template>
  <div :class="['max-w-600 rounded-lg field-wrapper']">
    <div class="label">
      <img src="../assets/shortAnswer.svg" alt="选择题" />
      <span class="px-2">简答题</span>
    </div>
    <div class="short-wrapper">
      <div :class="['title', isScrollInto ? 'bg-red-300' : '']">
        <h1 class="title-text text-l whitespace-pre-wrap">
          <span>{{ data.title.trim() }}</span>
          <!-- 分数配置 -->
          <span v-if="data.score">({{ data.score }}分)</span>
        </h1>
      </div>
      <textarea
        ref="textarea"
        v-model.trim="text"
        :disabled="isSubmit"
        :placeholder="data.placeholder || '在此处输入答案哦'"
        class="textarea"
      ></textarea>
    </div>
    <transition name="fade" mode="out-in">
      <div
        v-if="isSubmit && (data.answer || data.analysis)"
        class="answer px-4 py-2 mt-2 rounded-lg font-medium border border-gray-300 bg-white"
      >
        <p v-if="data.answer" class="text-gray-700">答案: {{ data.answer }}</p>
        <p v-if="data.analysis" class="text-gray-700">解析: {{ data.analysis }}</p>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { baseSurvey, SurveySaveData } from '../baseSurvey';

@Component({
  name: 'ShortAnswer'
})
export default class ShortAnswer extends Vue implements baseSurvey {
  @Prop({ type: Object }) data!: {
    $id: string;
    title: string;
    text: string;
    score: number;
    template?: string;
    placeholder?: string;
    reviewMark?: string;
  };
  @Prop({ type: Boolean }) isSubmit: boolean;
  @Prop({ type: Number }) index: number;

  text = '';

  isScrollInto = false;
  // px
  bufferHeight = 32;
  initializing = false;

  @Watch('text')
  checkContent() {
    this.$emit('fieldChange');
  }

  @Watch('text')
  changeText() {
    if (!this.initializing) {
      this.$el.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
    this.$nextTick(() => {
      const textarea = this.$refs?.textarea as HTMLTextAreaElement;
      textarea.style.height = '0px';
      textarea.style.height = textarea.scrollTop + textarea.scrollHeight + this.bufferHeight + 'px';
    });
  }

  mounted() {
    this.initializing = true;
    if (!this.text) this.text = this.data.template || '';
    this.$nextTick(() => {
      this.initializing = false;
    });
    this.$emit('addField', [this]);
  }

  updateUserAnswer(data: SurveySaveData) {
    if (!data) return;
    this.text = (data.content as { text: string }).text;
  }

  checkEmpty() {
    if (!this.text || (this.data.template && this.text === this.data.template)) return true;
    return false;
  }

  followField() {
    this.$el.scrollIntoView({ behavior: 'smooth' });
    this.isScrollInto = true;
    setTimeout(() => {
      this.isScrollInto = false;
    }, 700);
  }

  getValue() {
    return {
      index: this.index,
      type: 'text',
      title: this.data.title,
      content: {
        title: this.data.title,
        text: this.text
      }
    };
  }

  getMark() {
    return this.data.reviewMark;
  }
}
</script>

<style scoped>
.field-wrapper {
  transition: all 1s;
}
.short-wrapper {
  @apply rounded-lg flex flex-col overflow-hidden;
  border: 1px solid #d3d3d3;
}
.title {
  @apply w-full flex items-center text-lg;
  padding: 10px;
  border-bottom: 1px solid #d3d3d3;
  transition: all 1s;
}
.title-text {
  color: #1a051d;
}
.label {
  @apply mb-4 flex text-motif-500;
}

.textarea {
  @apply w-full ring-0 min-h-48 max-h-120 border-none resize-none;
  color: rgba(26, 5, 29, 0.5);
  line-height: 1.75rem;
  outline: none !important;
}

textarea:focus {
  color: #716774;
  background-color: #f7f7f7;
}

.answer p + p {
  @apply mt-2;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
